package one.healthium.uscreen.domain.models

import kotlinx.serialization.Serializable
import one.healthium.uscreen.serialization.GenderTextSerializer

@Serializable(with = GenderTextSerializer::class)
data class GenderText(
    val men: String,
    val women: String,
) {
    constructor(text: String) : this(text, text)

    fun resolve(isMale: Boolean?): String = if (isMale == true) men else women
}
